// Mirrors the backend ApplicantSubmissionTrigger enum, which the summary endpoint serializes by name.
export enum ApplicantSubmissionTrigger {
    Unknown = 'Unknown',
    Web = 'Web',
    WebInternalEdit = 'WebInternalEdit',
    Highway = 'Highway',
    OrpResubmit = 'OrpResubmit',
    AutoResubmit = 'AutoResubmit',
}

export interface ApplicantSubmissionSummary {
    id: string;
    dateCreated: string;
    trigger: ApplicantSubmissionTrigger;
    reviewerEmail: string | null;
}
